import axios from "axios";
import { PromiseHandler } from "../../handlers";
import { NotImplementedError } from "../../errors";
/**
 * KeywordTemplates module for managing IAS keyword templates.
 * Extends PromiseHandler to support standard mad-hooks patterns.
 */
export default class KeywordTemplates extends PromiseHandler {
    constructor(sdk) {
        super(sdk, "keywordTemplates");
        this.url = `${this.sdk.urls.baseAPIUrl}/ext-segments/keyword-template`;
    }
    /**
     * Download template via find_once()
     * Returns the keyword template as an xlsx file blob.
     * Template is pre-populated with advertisers available to the user
     * and any existing keywords.
     */
    async findItems() {
        const { data } = await axios.get(this.url, {
            responseType: "blob",
            headers: {
                Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            }
        });
        return [data];
    }
    /**
     * Upload template via save({ file })
     * Uploads a filled keyword template (xlsx file).
     * Upserts keywords and returns validation errors if any.
     */
    async saveItem(template) {
        const formData = new FormData();
        formData.append("file", template.file);
        return axios
            .post(this.url, formData)
            .then(({ data }) => data)
            .catch((error) => {
            // If the backend returned a structured error response, return it
            if (axios.isAxiosError(error) && error.response?.data) {
                return error.response.data;
            }
            // Otherwise throw for network errors, etc.
            throw error;
        });
    }
    async deleteItem() {
        throw new NotImplementedError("delete");
    }
}
//# sourceMappingURL=index.js.map